import { Chip, notify } from "design-react-kit";

import secureLocalStorage from "react-secure-storage";
import {
  createQueryString,
  getTokenFromCookie,
  sendApiRequest,
} from "./Base/base-service";
import StagedFlowStatusEnum from "../helpers/Enums/StagedFlowStatusEnum";
import FlowTypeEnum from "../helpers/Enums/FlowTypeEnum";

const filterHandler = (e, items, column) => {
  const value = e.target.value;
  let filteredResults = "";
  if (value === "") {
    filteredResults = items;
  } else if (
    e.nativeEvent.inputType === "deleteContentBackward" ||
    e.nativeEvent.inputType === "deleteContentForward"
  ) {
    filteredResults = items.filter((item) => {
      return item[column].toLowerCase().includes(value.toLowerCase());
    });
  } else {
    filteredResults = items.filter((item) => {
      return item[column].toLowerCase().includes(value.toLowerCase());
    });
  }
  return filteredResults;
};

const notifyUser = (message, state, icon, duration) => {
  notify(message, {
    icon: icon,
    state: state,
    dismissable: true,
    duration: duration !== undefined ? duration : 5000,
  });
};

const clearSecureStorage = () => {
  secureLocalStorage.clear();
};

const clearUserContext = (context) => {
  context.setSelectedClientFiscalCode(null);
  context.setSelectedClientName(null);
  context.setSelectedClientTwoFactorEnabled(null);
  context.setIsAdmin(null);
  context.setUserEmail(null);
  context.setUserId(null);
  context.setIsAIModuleAllowed(false);
  context.setIsEfModuleAllowed(false);
};

const changeDateFormat = (item, column) => {
  var date = item[column];
  if (date === null) {
    date = item["predispositionDate"];
  }

  const dateArray = date.split("/");
  const day = dateArray[0];
  const month = dateArray[1];
  const newDate = `${month}/${day}/${dateArray[2]}`;

  return newDate;
};

const sortData = (e, type, column, sortOrder, items, page) => {
  const icons = document.querySelectorAll(".sort");
  icons.forEach((icon) => icon.setAttribute("fill", "#dadce0"));
  const target = e.target.closest("svg");
  target.setAttribute("fill", "#000");
  let sortedValues;
  if (type === "number") {
    sortedValues = items.toSorted((a, b) =>
      sortOrder === "asc" ? a[column] - b[column] : b[column] - a[column],
    );
  } else if (type === "string") {
    sortedValues = items.toSorted((a, b) => {
      const fa = a[column].toLowerCase();
      const fb = b[column].toLowerCase();

      if (fa < fb) {
        return sortOrder === "asc" ? 1 : -1;
      }
      if (fa > fb) {
        return sortOrder === "asc" ? -1 : 1;
      }
      return 0;
    });
  } else if (type === "date") {
    sortedValues = items.toSorted((a, b) => {
      const dateA = new Date(changeDateFormat(a, column));
      const dateB = new Date(changeDateFormat(b, column));
      return sortOrder === "asc" ? dateB - dateA : dateA - dateB;
    });
  }
  return sortedValues;
};

const closeDropdown = () => {
  const dropdownList = document.querySelectorAll(".dropdown-menu");
  dropdownList.forEach((item) => item.classList.remove("show"));
};

const isAIModuleAllowedHandler = (
  fiscalCode,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
) => {
  sendApiRequest(
    `Client/IsAIModuleAllowed`,
    "GET",
    true,
    { fiscalCode, flowId: null },
    signIn,
    signOut,
    navigate,
    createQueryString,
    userContext,
  ).then((response) => {
    if (response !== undefined) {
      if (response.errors !== null) {
        setError(response.errors);
      } else {
        userContext.setIsAIModuleAllowed(response.data.result);
        secureLocalStorage.setItem("isAIModuleAllowed", response.data.result);
      }
    }
  });
};

const isEfModuleAllowedHandler = (
  fiscalCode,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
) => {
  sendApiRequest(
    `Client/IsEfModuleAllowed`,
    "GET",
    true,
    { fiscalCode, flowId: null },
    signIn,
    signOut,
    navigate,
    createQueryString,
    userContext,
  ).then((response) => {
    if (response !== undefined) {
      if (response.errors !== null) {
        setError(response.errors);
      } else {
        userContext.setIsEfModuleAllowed(response.data.result);
        secureLocalStorage.setItem("isEfModuleAllowed", response.data.result);
      }
    }
  });
};

const isAuthModuleAllowedHandler = (
  fiscalCode,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
) => {
  sendApiRequest(
    `Client/IsAuthModuleAllowed`,
    "GET",
    true,
    { fiscalCode, flowId: null },
    signIn,
    signOut,
    navigate,
    createQueryString,
    userContext,
  ).then((response) => {
    if (response !== undefined) {
      if (response.errors !== null) {
        setError(response.errors);
      } else {
        userContext.setIsAuthModuleAllowed(response.data.result);
        secureLocalStorage.setItem("isAuthModuleAllowed", response.data.result);
      }
    }
  });
};

const isStatisticModuleAllowedHandler = (
  fiscalCode,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
) => {
  sendApiRequest(
    `Client/IsStatisticModuleAllowed`,
    "GET",
    true,
    { fiscalCode, flowId: null },
    signIn,
    signOut,
    navigate,
    createQueryString,
    userContext,
  ).then((response) => {
    if (response !== undefined) {
      if (response.errors !== null) {
        setError(response.errors);
      } else {
        userContext.setIsStatisticModuleAllowed(response.data.result);
        secureLocalStorage.setItem(
          "isStatisticModuleAllowed",
          response.data.result,
        );
      }
    }
  });
};

const downloadFile = async (url, signIn, signOut, navigate, userContext) => {
  const token = getTokenFromCookie();

  if (isUrlWhitelisted(url)) {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          if (typeof signOut === "function") {
            clearSecureStorage();
            if (userContext !== undefined) {
              clearUserContext(userContext);
            }
            signOut();
            navigate("/");
          }
          return;
        } else {
          throw new Error((await response.json()).errors);
        }
      }

      if (
        response.headers.get("X-Auth-Token") !== null &&
        typeof signIn === "function"
      ) {
        if (
          signIn({
            token: response.headers.get("X-Auth-Token"),
            tokenType: "Bearer",
            expiresIn: Number(process.env.REACT_APP_TOKEN_EXPIRATION_TIME),
            authState: "Download",
          })
        ) {
        } else {
          throw new Error(["Something went wrong!"]);
        }
      }

      if (response.headers.get("Content-Disposition") !== null) {
        const filename = response.headers
          .get("Content-Disposition")
          .split(";")
          .find((el) => el.includes("filename"))
          .replace("filename=", "")
          .replace(/["']/g, "")
          .trim();
        secureLocalStorage.setItem("fileName", filename);
      }

      return response;
    } catch (error) {
      return { errors: error };
    }
  }
};

const downloadFlow = (
  method,
  stagedFlowId,
  setIsLoading,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
) => {
  setIsLoading(true);
  setError(null);
  downloadFile(
    `${process.env.REACT_APP_API_URL}StagedFlow/${method}/?stagedFlowId=${stagedFlowId}`,
    signIn,
    signOut,
    navigate,
    userContext,
  ).then(async (response) => {
    if (
      response !== undefined &&
      response.errors !== null &&
      response.errors !== undefined
    ) {
      setError([response.errors.message]);
    } else {
      if (!response.body) return;
      let fileName = "";
      if (
        response.headers !== null &&
        response.headers.get("Content-Disposition") !== null
      ) {
        fileName = response.headers
          .get("Content-Disposition")
          .split(";")
          .find((el) => el.includes("filename"))
          .replace("filename=", "")
          .replace(/["']/g, "")
          .trim();
      }

      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          notifyUser(
            `Scarica file ${fileName} completato`,
            "success",
            "it-check",
            5000,
          );
          break;
        }
        chunks.push(value);
      }

      const blob = new Blob(chunks);
      let url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;

      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    }
    setIsLoading(false);
  });
};

const showStatus = (flow, modalOpenHandler) => {
  if (
    flow.stagedFlowStatusId === StagedFlowStatusEnum.Valid ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.ReadyForCalculation ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.PriceCalculated ||
    flow.stagedFlowStatusId ===
      StagedFlowStatusEnum.ReadyForDigitalAddressCheck ||
    flow.stagedFlowStatusId ===
      StagedFlowStatusEnum.ReadyForTechAuthorization ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.TechAuthorized ||
    flow.stagedFlowStatusId ===
      StagedFlowStatusEnum.ReadyForEconAuthorization ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.EconAuthorized ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.Sent
  ) {
    return (
      <div
        title={`${flow.stagedFlowStatusLabel} ${
          flow.modifiedOn !== null
            ? `\nData ultima variazione: ${flow.modifiedOn}`
            : ""
        } ${
          flow.modifiedBy !== null
            ? `\nUltima variazione eseguita da: ${flow.modifiedBy}`
            : ""
        }`}
      >
        <span>
          <Chip color="success" className="text-nowrap">
            {flow.stagedFlowStatusLabel}
          </Chip>
        </span>
      </div>
    );
  } else if (
    flow.stagedFlowStatusId === StagedFlowStatusEnum.TechAuthInProgress ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.ReadyForSend ||
    flow.stagedFlowStatusId === StagedFlowStatusEnum.EconAuthInProgress
  ) {
    return (
      <div
        title={`${flow.stagedFlowStatusLabel} ${
          flow.modifiedOn !== null
            ? `\nData ultima variazione: ${flow.modifiedOn}`
            : ""
        } ${
          flow.modifiedBy !== null
            ? `\nUltima variazione eseguita da: ${flow.modifiedBy}`
            : ""
        }`}
      >
        <Chip color="info" className="text-nowrap">
          {flow.stagedFlowStatusLabel}
        </Chip>
      </div>
    );
  } else {
    if (
      flow.stagedFlowStatusId ===
        StagedFlowStatusEnum.NotValidForPriceCalculation ||
      flow.stagedFlowStatusId === StagedFlowStatusEnum.NotValid
    ) {
      return (
        <div
          style={{ cursor: "pointer" }}
          title={`${flow.stagedFlowStatusLabel} ${
            flow.modifiedOn !== null
              ? `\nData ultima variazione: ${flow.modifiedOn}`
              : ""
          } ${
            flow.modifiedBy !== null
              ? `\nUltima variazione eseguita da: ${flow.modifiedBy}`
              : ""
          }`}
          onClick={(e) => modalOpenHandler(flow)}
        >
          <Chip color="danger" className="text-nowrap">
            {flow.stagedFlowStatusLabel}
          </Chip>
        </div>
      );
    } else {
      return (
        <div
          title={`${flow.stagedFlowStatusLabel} ${
            flow.modifiedOn !== null
              ? `\nData ultima variazione: ${flow.modifiedOn}`
              : ""
          } ${
            flow.modifiedBy !== null
              ? `\nUltima variazione eseguita da: ${flow.modifiedBy}`
              : ""
          }`}
        >
          <Chip color="danger" className="text-nowrap">
            {flow.stagedFlowStatusLabel}
          </Chip>
        </div>
      );
    }
  }
};

const listOfRoles = [
  {
    value: "PAAdmin",
    label: "Amministratore utenze",
  },
  {
    value: "PAUser",
    label: "Operatore",
  },
  {
    value: "PASectorManager",
    label: "Responsabile di Settore",
  },
  {
    value: "PAEconomicalManager",
    label: "Responsabile Economico Notifiche",
  },
  {
    value: "Administrator",
    label: "Amministratore",
  },
];

const flowTypes = [
  {
    value: 0,
    label: "CSV",
  },
  {
    value: 1,
    label: "JSON",
  },
  {
    value: 2,
    label: "JSON_V2",
  },
];

const updateStagedFlowStatus = (
  data,
  setIsLoading,
  signIn,
  signOut,
  navigate,
  userContext,
  setError,
  getFlows,
  filters,
) => {
  setIsLoading(true);
  sendApiRequest(
    `StagedFlow/UpdateStagedFlowStatus`,
    "POST",
    true,
    data,
    signIn,
    signOut,
    navigate,
    null,
    userContext,
  ).then((response) => {
    if (response !== undefined && response.errors !== null) {
      setError(response.errors);
    } else {
      getFlows(filters);
    }
    setIsLoading(false);
  });
};

const showFlowType = (type) => {
  if (type === FlowTypeEnum.Csv) {
    return <span>csv</span>;
  } else if (type === FlowTypeEnum.Json) {
    return <span>json</span>;
  } else if (type === FlowTypeEnum.Json_v2) {
    return <span>json_v2</span>;
  }
};

const setFormatHandler = (format, setFormat) => {
  if (format === "CSV") {
    setFormat({ value: 0, label: format });
  } else if (format === "JSON") {
    setFormat({ value: 1, label: format });
  } else if (format === "JSON_V2") {
    setFormat({ value: 2, label: format });
  }
};

const isUrlWhitelisted = (url) => {
  const whiteList = [
    `${process.env.REACT_APP_API_URL}Activation/SelfActivation`,
    `${process.env.REACT_APP_API_URL}Activation/ConfirmEmail`,
    `${process.env.REACT_APP_API_URL}Authentication/Login`,
    `${process.env.REACT_APP_API_URL}Authentication/LoginTwoFactorAuth`,
    `${process.env.REACT_APP_API_URL}Authentication/ResendTwoFactorAuthCode`,
    `${process.env.REACT_APP_API_URL}Authentication/Logout`,
    `${process.env.REACT_APP_API_URL}Client/GetClientLogo`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClientsForUpload`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClientCodesWithExternalConfiguration`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClientCodesWithStagedFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClientCodes`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClientCodesWithInadServiceConfiguration`,
    `${process.env.REACT_APP_API_URL}Client/GetAllClients`,
    `${process.env.REACT_APP_API_URL}Client/SaveLastClient`,
    `${process.env.REACT_APP_API_URL}Client/IsAIModuleAllowed`,
    `${process.env.REACT_APP_API_URL}Client/IsEfModuleAllowed`,
    `${process.env.REACT_APP_API_URL}Client/IsAuthModuleAllowed`,
    `${process.env.REACT_APP_API_URL}Client/IsStatisticModuleAllowed`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetClientConfigurations`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetClientDocumentFieldConfigs`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetSupportedDocumentTypes`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetSingleClientConfiguration`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/UpsertClientConfiguration`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetKeyPhrases`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/UpsertClientDocumentFieldConfig`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/UpsertSingleClientDocumentRule`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/GetClientDocumentRules`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/DeleteClientConfiguration`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/DeleteClientDocumentRule`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/DeleteClientDocumentFieldConfig`,
    `${process.env.REACT_APP_API_URL}ClientConfiguration/CopyClientDocumentsRules`,
    `${process.env.REACT_APP_API_URL}Common/GetAllFlowStatuses`,
    `${process.env.REACT_APP_API_URL}Common/GetAllExternalFlowStatuses`,
    `${process.env.REACT_APP_API_URL}Common/GetStagedFlowStatusesForTechAuth`,
    `${process.env.REACT_APP_API_URL}Common/GetStagedFlowStatusesForEconAuth`,
    `${process.env.REACT_APP_API_URL}Common/GetStagedFlowStatusesForNotValidAuth`,
    `${process.env.REACT_APP_API_URL}Common/GetStagedFlowStatusesForArchive`,
    `${process.env.REACT_APP_API_URL}Common/GetNotificationWarnings`,
    `${process.env.REACT_APP_API_URL}Document/GetFilePreSignedUrls`,
    `${process.env.REACT_APP_API_URL}DocumentAnalysis/GetAllAnalyzedFiles`,
    `${process.env.REACT_APP_API_URL}DocumentAnalysis/GetFileAnalysisResult`,
    `${process.env.REACT_APP_API_URL}DocumentAnalysis/CheckFileAnalysisPresence`,
    `${process.env.REACT_APP_API_URL}DocumentAnalysis/RunDocumentAnalysis`,
    `${process.env.REACT_APP_API_URL}DocumentAnalysis/UploadDocument`,
    `${process.env.REACT_APP_API_URL}DocumentCheck/GetAllFileGroups`,
    `${process.env.REACT_APP_API_URL}DocumentCheck/RunDocumentCheck`,
    `${process.env.REACT_APP_API_URL}DocumentCheck/GetDocumentCheckResult`,
    `${process.env.REACT_APP_API_URL}DocumentCheck/DeleteFileGroup`,
    `${process.env.REACT_APP_API_URL}DocumentCheck/GetDocumentCheckMergedResults`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/GetExternalFlows`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/UploadZip`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/UploadZipWithSignature`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/DownloadZip`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/DownloadZipForSignature`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/DownloadZipWithSignature`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/AuthorizeExternalFlowForSending`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/DeleteExternalFlow`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/DeleteZipWithSignature`,
    `${process.env.REACT_APP_API_URL}ExternalFlow/GetValidationErrors`,
    `${process.env.REACT_APP_API_URL}ExternalFlowConfiguration/DeleteExternalFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}ExternalFlowConfiguration/GetExternalFlowConfigurations`,
    `${process.env.REACT_APP_API_URL}ExternalFlowConfiguration/GetSingleExternalFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}ExternalFlowConfiguration/UpsertExternalFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}Flow/GetReadyFlowNotifications`,
    `${process.env.REACT_APP_API_URL}Flow/GetFlows`,
    `${process.env.REACT_APP_API_URL}Flow/GetReadyFlows`,
    `${process.env.REACT_APP_API_URL}Flow/AuthorizeFlowForSending`,
    `${process.env.REACT_APP_API_URL}FLow/GetFlowHistory`,
    `${process.env.REACT_APP_API_URL}Flow/DownloadFlowResultFile`,
    `${process.env.REACT_APP_API_URL}Inad/GetSingleStagedFlowInadConfiguration`,
    `${process.env.REACT_APP_API_URL}Log/LogS3BucketUploadResult`,
    `${process.env.REACT_APP_API_URL}Municipality/SetTwoFactorAuth`,
    `${process.env.REACT_APP_API_URL}Municipality/GetAllCadastralCodesByMunicipalityName`,
    `${process.env.REACT_APP_API_URL}Notification/FixNotification`,
    `${process.env.REACT_APP_API_URL}Notification/getInvalidNotificationData`,
    `${process.env.REACT_APP_API_URL}Notification/getNotificationData`,
    `${process.env.REACT_APP_API_URL}Notification/GetInvalidNotifications`,
    `${process.env.REACT_APP_API_URL}Notification/DeleteInvalidNotification`,
    `${process.env.REACT_APP_API_URL}Notification/InvalidateNotification`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/GetInvalidNotificationsPaymentData`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/GetNotificationPaymentFiles`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/GetNotificationF24PageData`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/FixF24DataNotification`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/VerifyPaymentDataNotification`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/GetNotificationPagoPaPayment`,
    `${process.env.REACT_APP_API_URL}NotificationPaymentData/FixNotificationPagoPaPayment`,
    `${process.env.REACT_APP_API_URL}Password/ChangePasswordSelf`,
    `${process.env.REACT_APP_API_URL}Password/RequestChangePassword`,
    `${process.env.REACT_APP_API_URL}Password/RequestResetPassword`,
    `${process.env.REACT_APP_API_URL}StagedFlow/GetStagedFlowErrorInfo`,
    `${process.env.REACT_APP_API_URL}StagedFlow/GetStagedFlowHistoryErrorInfo`,
    `${process.env.REACT_APP_API_URL}StagedFlow/GetStagedFlowStatusesHistory`,
    `${process.env.REACT_APP_API_URL}StagedFlow/DeleteFlow`,
    `${process.env.REACT_APP_API_URL}StagedFlow/DownloadFlow`,
    `${process.env.REACT_APP_API_URL}StagedFlow/DownloadDocuments`,
    `${process.env.REACT_APP_API_URL}StagedFlow/UpdateStagedFlowStatus`,
    `${process.env.REACT_APP_API_URL}StagedFlowConfiguration/GetSingleStagedFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}StagedFlowConfiguration/UpsertStagedFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}StagedFlowConfiguration/DeleteStagedFlowConfiguration`,
    `${process.env.REACT_APP_API_URL}StagedFlowConfiguration/GetStagedFlowConfigurations`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotification/GetStagedFlowNotificationRecipients`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotifications/GetStagedFlowNotificationsForEcon`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotifications/GetStagedFlowNotificationsForTech`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotifications/GetStagedFlowNotificationsForTechV2`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotificationFiles/GetStagedFlowNotificationFiles`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotificationFiles/GetStagedFlowNotificationAttachments`,
    `${process.env.REACT_APP_API_URL}StagedFlowNotificationFiles/GetStagedFlowNotificationRecipientPaymentFiles`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetStagedFlowsCounts`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetAllStagedFlowsForArchive`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetAllStagedFlowsForTechApproval`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetAllStagedFlowsForEconApproval`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetAllStagedFlowsCostNotCalculated`,
    `${process.env.REACT_APP_API_URL}StagedFlows/GetAllStagedFlowsNotValid`,
    `${process.env.REACT_APP_API_URL}Statistics/GetSummary`,
    `${process.env.REACT_APP_API_URL}Statistics/GetFirstStartYear`,
    `${process.env.REACT_APP_API_URL}User/GetUserRoles`,
    `${process.env.REACT_APP_API_URL}User/DeleteUser`,
    `${process.env.REACT_APP_API_URL}User/GetAllUsers`,
    `${process.env.REACT_APP_API_URL}User/UpsertUser`,
  ];

  try {
    const inputUrl = new URL(url);
    const inputArr = inputUrl.pathname.split("/");
    const normalizedInput = `${inputUrl.origin}/${inputArr[1]}/${inputArr[2]}`;
    return whiteList.some((allowed) => {
      const allowedUrl = new URL(allowed);
      return (
        normalizedInput.toLowerCase() ===
        (allowedUrl.origin + allowedUrl.pathname).toLowerCase()
      );
    });
  } catch (e) {
    return false;
  }
};

function constantTimeEqualsHelper(a, b) {
  if (a.length !== b.length) return false;

  let result = 0;
  for (let i = 0; i < a.length; i++) {
    result |= a[i] ^ b[i]; // XOR each byte
  }
  return result === 0;
}

function getLocalStorageByPattern(targetKeySuffix) {
  const pattern = new RegExp(
    `^${process.env.REACT_APP_SECURE_LOCAL_STORAGE_PREFIX}\\.(.+)\\.${targetKeySuffix}$`,
  );

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && pattern.test(key)) {
      return localStorage.getItem(key);
    }
  }

  return null;
}

const buildMonthlyData = (data) => {
  const result = [];

  for (let month = 12; month >= 1; month--) {
    const services = data.map((service) => {
      const monthStats = service.statistics.find((s) => s.month === month);
      return {
        code: service.code,
        ...monthStats,
      };
    });

    const total = services.reduce(
      (acc, s) => {
        acc.sent += s.sent === undefined ? 0 : s.sent;
        acc.digitalSuccess +=
          s.digitalSuccess === undefined ? 0 : s.digitalSuccess;
        acc.analogicalSuccess +=
          s.analogicalSuccess === undefined ? 0 : s.analogicalSuccess;
        acc.paid += s.paid === undefined ? 0 : s.paid;
        return acc;
      },
      { code: "", sent: 0, digitalSuccess: 0, analogicalSuccess: 0, paid: 0 },
    );

    result.push({
      month,
      services,
      total,
    });
  }

  return result;
};

export {
  filterHandler,
  notifyUser,
  clearSecureStorage,
  clearUserContext,
  sortData,
  closeDropdown,
  isAIModuleAllowedHandler,
  isEfModuleAllowedHandler,
  isAuthModuleAllowedHandler,
  isStatisticModuleAllowedHandler,
  downloadFlow,
  showStatus,
  listOfRoles,
  flowTypes,
  updateStagedFlowStatus,
  showFlowType,
  setFormatHandler,
  isUrlWhitelisted,
  constantTimeEqualsHelper,
  getLocalStorageByPattern,
  buildMonthlyData,
};
